import { HeadCell, ACTION} from '../../../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'destino', label: 'Loja' },
  { id: 'tipoVeiculo', label: 'Tipo de Veículo ' },
  { id: 'horarioInicio', label: 'Horário Início' },
  { id: 'horarioFim', label: 'Horário Fim'},
  { id: ACTION, label: ''},
];